import $axios from '../config.js'
import { url } from '../api_urls/concept.js'
import {
  _upload
} from '../request.js'
// example
// export function getTableData () {
//   return $axios({
//     url: 'xxxxxx',
//     method: 'get'
//   })
// }
// 获取basf upload concept列表数据
export function getTableUploadData (params) {
  console.log(url.listupload)
  return $axios.post(url.listupload, params)
}
// 获取basf management concept列表数据
export function getTableData (params) {
  console.log(url.list)
  return $axios.post(url.list, params)
}

// 获取basf segment列表数据
export function getSegmentData (params) {
  console.log(url.segment)
  return $axios.post(url.segment, params)
}

// 获取upload withdraw数据
export function getUploadWithdrawData (params) {
  return $axios.post(url.withdraw, params)
}
// 获取basf uploadfile数据
export function getUploadFileData (params) {
  return _upload(url.uploadfile, params)
}
// 获取basf files数据，最多30个
export function getFileListData (params) {
  return $axios.get(url.FILES_LIST, {
    params: {
      fileIds: params
    }
  })
}
// 获取basf edit数据
export function getEditDetailData (params) {
  return $axios.post(url.detail, params)
}
// 获取management edit数据
export function getManagementEditData (params) {
  return $axios.post(url.managementEdit, params)
}
// 获取basf 保存草稿数据
export function getEditDraftData (params) {
  return $axios.post(url.draft, params)
}
// 获取approval upload模块 pengding-approve withdraw
export function getApprovalData (params) {
  return $axios.post(url.approval, params)
}
// 获取preview management模块 pending-approval 预览
export function getManagementPreviewData (params) {
  return $axios.post(params.isUpload ? url.DETAIL : url.detail, params, params)
}
// 获取management模块 total count
export function getManagementCountData (params) {
  return $axios.post(url.managementConceptCount, params)
}
// 获取upload模块 total count
export function getUploadCountData (params) {
  return $axios.post(url.uploadConceptCount, params)
}

// 关联图片和文件RELATE_FILE_IMAGE
export function relateFileImage (params) {
  return $axios.post(url.RELATE_FILE_IMAGE, params)
}

// 获取配方的id与name
export function getFormulationIdData (params) {
  return $axios.post(url.FORMULATION_ID, params)
}
// 获取详细页数据
export function getDetailData (params) {
  return $axios.post(url.DETAIL, params)
}
// 获取tradeName的id与name
export function getTradeNameIdData (params) {
  return $axios.post(url.TRADENAME_ID, params)
}

// 获取claim-performance数据
export function getClaimData (params) {
  return $axios.post(url.CLAIM, params)
}
// 获取approver数据
export function getSearchApproveUserListData (params) {
  return $axios.post(url.searchApproveUserList, params)
}
// 获取submit by数据
export function getSearchUserListListData (params) {
  return $axios.post(url.searchUserList, params)
}

export function handleEnable (params) {
  return $axios.post(url.handleEnable, params)
}

export function setNewConcept (params) {
  return $axios.post(url.setNewConcept, params)
}

export function getTrend (params) {
  return $axios.post(url.getTrend, params)
}
// 获取Media list
export function getMediaList (params) {
  return $axios.post(url.getMediaList, params)
}

// 通过isUpload 参数判断是管理后台还是upload
export function getDetailByAuth (params) {
  return $axios.post(params.isUpload ? url.DETAIL : url.detail, params)
}

export function getUploadConceptCount (params) {
  return $axios.post(url.getUploadConceptCount)
}

export function deleteDraft (params) {
  return $axios.post(url.deleteDraft, params)
}

// 设置Key focus product
export function setKeyProduct (params) {
  return $axios.post(url.setKeyProduct, params)
}


// WEBPACK FOOTER //
// ./src/axios/api/concept.js